import { render, staticRenderFns } from "./ModalAccountChangeEmail.vue?vue&type=template&id=79dc9f72&scoped=true"
import script from "./ModalAccountChangeEmail.vue?vue&type=script&lang=js"
export * from "./ModalAccountChangeEmail.vue?vue&type=script&lang=js"
import style0 from "./ModalAccountChangeEmail.vue?vue&type=style&index=0&id=79dc9f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc9f72",
  null
  
)

export default component.exports